enum TimelineDataActions {
	NEW = 'CREATE_NEW',
	LOADED = 'LOADED',
	UPDATE_DATA = 'timeline_update_data',
	ADD_WIDGET = 'timeline_add_widget',
	ADD_MESSAGE = 'timeline_add_message',
	REMOVE_MESSAGE = 'timeline_remove_message',
	CHANGE_MESSAGE = 'timeline_change_message',
	DUPLICATE_WIDGET = 'timeline_duplicate_widget',
	DUPLICATE_WIDGETS = 'timeline_duplicate_widgets',
	REMOVE_WIDGET = 'timeline_remove_widget',
	REMOVE_WIDGETS = 'timeline_remove_widgets',
	CHANGE_WIDGET = 'timeline_change_widget',
	ADD_REMOVE_TAG_ON_WIDGETS = 'timeline_add_remove_tag_on_widget',
	CHANGE_WIDGET_CONFIG = 'timeline_change_widget_config',
	CHANGE_WIDGETS_SAME_CONFIG = 'timeline_change_widgets_same_config',
	CHANGE_WIDGETS_DIFFERENT_CONFIG = 'timeline_change_widgets_different_config',
	CHANGE_GROUP_TAG_LABEL = 'timeline_change_group_tag_label',
	CHANGE_GROUP_TAGS = 'timeline_change_group_tags',
	CHANGE_FORM_FIELD = 'timeline_change_form_field',
	ADD_TRACKGROUP = 'timeline_add_trackgroup',
	REMOVE_TRACKGROUP = 'timeline_remove_trackgroup',
	CHANGE_TRACKGROUP = 'timeline_change_trackgroup',
	UNGROUP_TRACKGROUP = 'timeline_ungroup_trackgroup',
	IMPORT_TIMELINE_DATA = 'timeline_import_timeline_data',
	SET_ENDSCREEN_AREA = 'timeline_set_endscreen_area',
	SET_DESIGN_DIMENSIONS = 'timeline_set_design_dimensions',

	ADD_TRACK = 'timeline_add_track',
	REMOVE_TRACK = 'timeline_remove_track',

	ADD_KEYFRAME = 'timeline_add_keyframe',
	CHANGE_KEYFRAME = 'timeline_change_keyframe',
	REMOVE_KEYFRAME = 'timeline_remove_keyframe',

	ADD_TRACK_TO_TRACKGROUP = 'timeline_add_track_to_trackgroup', // replace with UPDATE_TRACK_ORDER ?
	UPDATE_TRACK_ORDER = 'timeline_update_track_order',
	REMOVE_TRACK_FROM_TRACKGROUP = 'timeline_remove_track_from_trackgroup', // replace with UPDATE_TRACK_ORDER ?
	CHANGE_IN_OUT_POINT = 'timeline_change_in_out_point',
	MOVE_TRACK_TO_INDEX = 'timeline_move_track_to_index', // replace with UPDATE_TRACK_ORDER ?
	MOVE_SELECTED_TRACKS_TO_INDEX = 'timeline_move_selected_tracks_to_index' // replace with UPDATE_TRACK_ORDER ?
}

export { TimelineDataActions };
